
import { ChangeDetectionStrategy, Component, DestroyRef, Input, OnChanges, OnInit, ViewEncapsulation, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { AbstractControl } from '@angular/forms'
import { TooltipPosition } from '@angular/material/tooltip'
import { TranslateModule } from '@ngx-translate/core'
import { FcMaintenanceSelectService } from './fc-maintenance-select.service'
import { MaintenancesService } from '../../core/api/maintenances/maintenances.service'
import { FcSelectPagedComponent } from '../fc-select-paged/fc-select-paged.component'

@Component({
    selector: 'app-fc-maintenance-select',
    templateUrl: './fc-maintenance-select.component.html',
    styleUrls: ['./fc-maintenance-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: [
    FcSelectPagedComponent,
    TranslateModule
],
    providers: [
        MaintenancesService,
        FcMaintenanceSelectService
    ]
})
export class FcMaintenanceSelectComponent implements OnInit, OnChanges {
  @Input() public control!: AbstractControl | null
  @Input() public placeholder: string = ''
  @Input() public companiesIds: string[] | null = []
  @Input() public fcTooltip: string = ''
  @Input() public fcTooltipDisabled: boolean = true
  @Input() public fcTooltipPosition: TooltipPosition = 'above'

  private readonly destroyRef = inject(DestroyRef)
  public readonly fcMaintenanceSelectService = inject(FcMaintenanceSelectService)

  public ngOnInit(): void {
    this.fcMaintenanceSelectService.reset()
    this.control?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((maintenance) => {
      if (!maintenance) return
      const name = `${maintenance?.number} - ${maintenance?.maintenanceType?.name} - ${maintenance?.segment?.name} - ${maintenance?.location?.name}`
      Object.assign(maintenance, { name })
      this.control?.setValue(maintenance, {
        emitEvent: false,
      })
    })
  }

  public ngOnChanges(changes: any): void {
    if (changes.companiesIds &&  JSON.stringify(changes.companiesIds.currentValue) === JSON.stringify(changes.companiesIds.previousValue)) {
      return
    }

    this.fcMaintenanceSelectService.filterForm.get('companyId_in')?.setValue(this.companiesIds)
    this.fcMaintenanceSelectService.filterForm.get('archived')?.setValue(false)
    this.fcMaintenanceSelectService.shouldUpdateOptions$.next()
  }
}
